
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 0a10 10 0 1010 10A10.011 10.011 0 0010 0zm0 18.182A8.182 8.182 0 1118.182 10 8.191 8.191 0 0110 18.182z","fill":"#661e99"}}),_c('path',{attrs:{"d":"M10 4.168a1.371 1.371 0 101.25 1.366A1.314 1.314 0 0010 4.168zM10 7.87a.984.984 0 00-.938 1.024v6.146a.941.941 0 101.875 0V8.894A.984.984 0 0010 7.87z","fill":"#661e99"}})])
          )
        }
      }
    